var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcondiscussionDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_158_322)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.9997 12V3C21.9997 2.20435 21.6836 1.44129 21.121 0.87868C20.5584 0.31607 19.7953 0 18.9997 0L4.99969 0C4.20405 0 3.44098 0.31607 2.87837 0.87868C2.31577 1.44129 1.99969 2.20435 1.99969 3V12H21.9997Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 14.0006V16.0006H11V20.0006H9C8.20435 20.0006 7.44129 20.3167 6.87868 20.8793C6.31607 21.4419 6 22.205 6 23.0006V24.0006H8V23.0006C8 22.7354 8.10536 22.481 8.29289 22.2935C8.48043 22.106 8.73478 22.0006 9 22.0006H15C15.2652 22.0006 15.5196 22.106 15.7071 22.2935C15.8946 22.481 16 22.7354 16 23.0006V24.0006H18V23.0006C18 22.205 17.6839 21.4419 17.1213 20.8793C16.5587 20.3167 15.7956 20.0006 15 20.0006H13V16.0006H24V14.0006H0Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_158_322"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcondiscussionDark);
export default __webpack_public_path__ + "static/media/icon=discussion-dark.f4b36adbf66d2fc3a130430f35af6ae5.svg";
export { ForwardRef as ReactComponent };